import component from './StreamablePost';
import handles from './handles';

export default {
  component,
  handles,
};



// WEBPACK FOOTER //
// ./src/components/StreamablePost/index.js